const S=(whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps)=>({whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps});
const N=(id,title,when,description)=>({id,title,...(description?{description}:{}),when});
export const zh={
cardiology:{
assessment:S('心脏科评估通常从讨论您的症状和用药并进行检查开始。您可能需要心电图、验血、超声心动图、心律监测或其他影像检查。在某些情况下可能会进行肌钙蛋白血液检测。需要哪些检查取决于您的症状以及团队想要回答的临床问题。','心脏症状可能有多种原因，不同检查能反映心脏功能的不同方面。','团队会查找需要紧急处理的问题，复核药物和风险因素，解读检查结果，并判断在制定计划前是否还需要更多信息。','并非每个人都需要相同的检查。有些可以一次完成，有些需要后续预约或更长时间的监测。',[
N('plan-treatment','制定治疗或监测计划','当团队已有足够信息可以解释下一步时'),
N('more-tests','安排更多检查或专科评估','如果第一次评估仍不能完全解释症状或风险','可能需要其他检查、心律记录、血液检查或更多专科意见。')
]),
treatment:S('治疗可能包括药物、更密切的监测、生活方式支持或某项操作。根据病情，您可能会听到冠状动脉造影、血管成形术或支架等词。','不同心脏问题需要不同治疗。目标可能是改善血流、控制心律或血压、减轻心脏负担、缓解症状或降低未来风险。','团队会权衡每种方案的收益和风险，复核药物，安排必要的操作或监测，并评估您的反应。','转诊到心脏科并不自动意味着需要进行操作。如果检查结果、症状或总体健康状况变化，计划也可能调整。',[
N('continue-treatment','继续治疗和监测','如果当前计划有效且仍需要复查'),
N('procedure-pathway','进入计划中的心脏操作流程','如果团队建议进行操作，并且您讨论后决定继续','如果团队认为操作可能改善症状或降低风险，就可能安排进行。'),
N('adjust-plan','调整或细化治疗计划','如果症状、结果或副作用使其他方案更合适')
]),
'follow-up':S('随访可能包括复查症状、药物、血压、检查结果以及操作后的恢复。有些人会参加心脏康复，包括有监督的活动、教育和支持。','心脏疾病通常需要持续复查，因为症状、药物和风险会随时间变化。','团队会评估进展、确认药物是否合适，必要时安排重复检查，并决定随访能否减少或转回基层医疗。','不同疾病的随访安排不同。您应知道哪些症状需要提前寻求建议，而不是等到下一次常规预约。',[
N('specialist-follow-up','继续心脏科随访','如果仍需要专科监测、药物调整或恢复评估'),
N('primary-care','由全科医生或社区团队继续照护','如果不再需要定期医院专科随访'),
N('earlier-review','症状变化时提前寻求建议','如果出现需要尽快评估的新症状或加重症状','请按照团队提供的安全提示处理，不要等待常规预约。')
])},
respiratory:{
assessment:S('呼吸系统评估可能包括测量血氧饱和度、听诊胸部，以及复查症状、吸入药物和既往肺部问题。检查可能包括肺活量测定、胸部X光或CT、血液检查，有时还会做血气检查。','气促、咳嗽和其他呼吸症状可能有多种原因。不同检查会评估气流、氧气、感染、炎症和肺部结构。','团队会评估病情严重程度，选择最有帮助的检查，复核药物和吸入器使用方法，并判断是否需要紧急治疗或更密切监测。','并非每个人都需要全部呼吸检查。有些检查在病情稳定时更有用，有些则用于急性发病期。',[
N('treatment-plan','制定治疗和监测计划','当评估提供足够信息来指导治疗时'),
N('more-investigation','安排进一步检查或专科评估','如果第一次评估仍不能完全解释症状','可能需要更多影像、肺功能检查或其他检查。')
]),
treatment:S('治疗取决于原因和严重程度，可能包括吸入药或其他药物、氧疗、雾化治疗、呼吸物理治疗或监测。某些特定情况下，有些人需要CPAP等无创呼吸支持。','不同治疗可以帮助扩张气道、治疗感染或炎症、改善氧气水平、清除分泌物或支持呼吸。','团队会监测呼吸和血氧，评估治疗是否有效，并在适当时调整药物或氧气。','并非所有气促患者都需要氧气、抗生素、雾化或CPAP。团队应解释哪些治疗适合您，以及为什么。',[
N('continue-treatment','继续治疗和监测','如果仍需要积极治疗或观察'),
N('step-down','呼吸改善后逐步减少治疗','如果血氧需求、症状或观察指标改善到可以进入恢复阶段'),
N('escalate-care','增加呼吸支持或请其他专科评估','如果当前方案提供的支持不够','如果病情恶化或未按预期反应，团队可能会加强监测或治疗。')
]),
'follow-up':S('随访可能包括重复肺功能检查、复核吸入药和其他药物、影像、氧气评估或康复。有些人会从肺康复中获益。','呼吸系统疾病会随时间变化，急性加重或住院后的恢复也可能是逐步的。','团队会复查症状和功能、吸入器使用和药物，必要时安排重复检查，并决定需要哪些专科或社区支持。','有些人需要长期呼吸科随访，有些人主要由基层医疗管理。如果在下一次预约前呼吸加重，请使用团队提供的安全提示。',[
N('rehab-follow-up','继续呼吸科随访或肺康复','如果仍需要专科复查、康复或重复检查'),
N('community-care','由基层或社区服务继续照护','如果无需定期医院专科随访也能安全管理'),
N('earlier-review','呼吸加重时提前寻求建议','如果出现需要快速评估的加重症状')
])},
endoscopy:{
preparing:S('内镜检查前请遵循您这项检查的具体准备说明。可能包括禁食、部分检查需要的肠道准备，或调整抗凝药、糖尿病药物等。','准备有助于团队清楚观察，并减少可避免的风险。具体要求会因检查部位以及是否计划镇静而不同。','团队会确认准备是否充分，复核药物和过敏史，确认检查原因，并确保您在同意前有机会提问。','胃镜、结肠镜和其他内镜的准备并不相同。请始终按照您所在医院给出的具体说明。',[
N('ready-procedure','按计划进行内镜检查','当准备和安全检查完成后'),
N('adjust-plan','延期、重新准备或调整计划','如果准备不充分或某个安全问题需要澄清','可能需要更多准备、补充信息或调整药物。')
]),
procedure:S('检查前会确认身份、知情同意和舒适方案。您可能接受局部麻醉、止痛或镇静，也可能使用静脉套管。内镜过程中，如果需要在实验室检查组织，团队可能会取活检。','内镜可以直接观察消化系统的一部分，并在合适时取样或在同一次检查中进行治疗。','内镜团队会进行计划中的检查，并监测您的舒适度和生命体征。他们会记录看到的情况。如果临床上合适并且属于已同意的计划，他们可能会取样或进行治疗。','有些内镜不使用镇静，有些使用清醒镇静，少数需要麻醉支持。取活检本身并不意味着就是癌症。',[
N('routine-recovery','检查后进入恢复区','当计划中的检查或治疗完成后'),
N('extra-treatment','额外治疗或观察','如果检查过程中发现需要更多治疗或监测的问题','有时需要处理某个发现、延长观察或安排进一步临床评估。')
]),
recovery:S('内镜后，工作人员会检查恢复情况并说明何时可以进食、饮水和离开。如果使用了镇静，您可能需要有人陪同回家。即时所见有时当天就能说明，但活检结果通常需要更长时间。','恢复检查用于确认在检查和镇静后安全离开。采集的样本需要实验室处理。','团队会监测恢复情况，提供出院说明，并安排如何告知检查结果、活检结果或后续随访。','恢复速度和结果时间取决于检查类型、镇静以及是否取样。请按照内镜科提供的安全提示处理。',[
N('home','带着恢复说明回家','当您符合出院标准并已安排所需陪同人员时'),
N('await-results','等待活检或正式结果','如果取了样本或报告还需要进一步审核'),
N('follow-up','如有需要参加后续随访或治疗','如果检查发现意味着需要另一次预约、检查或治疗')
])}
};